'use client'; // remove with zendesk feature flag

import React from 'react';

import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Text } from '../../Text/Text';
import { FeatureFlag } from '../../FeatureFlag/FeatureFlag';

export const CancellationText = ({ className = '' }: { className?: string }) => {
  return (
    <div className={`mt-4 mb-6 flex text-center ${className}`}>
      <Text variant="sm" className="m-0">
        Recurring billing,{' '}
        <FeatureFlag
          featureFlag="zendesk"
          newComponent={
            <ExternalLink
              href="https://fishbrainhelp.zendesk.com/hc/en-us/articles/22539074583836-How-do-I-cancel-my-Web-subscription"
              variant="textNone"
              target="_blank"
              className="underline"
            >
              cancel
            </ExternalLink>
          }
          oldComponent={
            <ExternalLink
              href="https://fishbrain.helpshift.com/hc/en/3-fishbrain---social-fishing-forecast-app/faq/180-how-do-i-cancel-my-web-subscription/"
              variant="textNone"
              target="_blank"
              className="underline"
            >
              cancel
            </ExternalLink>
          }
        />{' '}
        anytime
      </Text>
    </div>
  );
};
